import React from 'react';
import CircledIcon from './CircledIcon';

const ValueProposition = ({ analysis, displayFormula }) => {
  return (
    <div className={displayFormula ? 'py-5 px-2 px-sm-5 bg-light' : 'py-5 px-2 px-sm-5'}>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="pb-2 font-weight-bold text-center">
            Your Headline's Unique Value Proposition
          </h1>
        </div>
        <h6 className="text-center">
          When hiring for new roles, employers want to know exactly what
          candidates will be able to do for them. By including a Unique Value
          Proposition in your headline, you'll show them the value that you
          bring to the table.
        </h6>

        <div className="row mt-4 d-flex align-items-center">
          <div className="col-12 col-md-3 col-lg-2">
            <h5 className="font-weight-bold text-primary">Formula:</h5>
          </div>
          <div className="col">
            <h5 className="font-weight-bold">
              I Help [Organization Type] [Insert Achievement] [Insert Measurable
              Outcome]
            </h5>
          </div>
        </div>

        <div className="row mt-4 d-flex align-items-center">
          <div className="col-12 col-md-3 col-lg-2">
            <h5 className="font-weight-bold text-primary">Example:</h5>
          </div>
          <div className="col">
            <h5 className="font-weight-bold">
              I Help Hospitals Use Big Data To Reduce Readmission Rates By 17%
            </h5>
          </div>
        </div>

        <div className="px-sm-5 pt-3 d-flex justify-content-center">
          <div className="my-auto">
            <CircledIcon value={analysis?.valueProp} />
          </div>
          <h6 className="my-auto ml-3 d-inline-block">
            {analysis?.valueProp
              ? 'Your Headline has a unique value proposition! Nice work!'
              : "Your Headline doesn't tell employers what value you'll drive for them. Try adding a pitch with measurable outcomes."}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default ValueProposition;
